import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-schema',
  templateUrl: './schema.component.html',
  styleUrls: ['./schema.component.css']
})
export class SchemaComponent implements OnInit {

  @Input() url: string = "";
  isMultiple = false;
  schematas;
  height=300;
  width=300;
  ratio = 361.24/211.67;
  constructor() { }

  ngOnInit() {
    this.url = "";
    this.isMultiple = false;
    this.height = window.innerHeight - 120 - 120 -64;
    this.width = this.height * this.ratio;
  }
  setImage(target: any){
    if(Array.isArray(target)){
      this.height = window.innerHeight - 120 -120 -64;
      this.width = this.height * this.ratio;
      this.isMultiple = true;
      this.schematas = target;
      for (var i=0;i<this.schematas.length; i++){
        this.schematas[i].height = this.height;
        this.schematas[i].width = this.width;
      }
    } else {
      this.height = window.innerHeight - 64 - 120;
      this.width = this.height * this.ratio;
      this.isMultiple = false;
      this.url = "assets/schema/"+target;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/schema.component.ts